import { Component, Input, HostListener } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MatTooltipModule } from '@angular/material/tooltip'
import { Clipboard } from '@angular/cdk/clipboard'

@Component({
  selector: 'app-ellipsis-tooltip',
  standalone: true,
  imports: [CommonModule, MatTooltipModule],
  template: `
    <span
      [matTooltip]="isTruncated ? content : ''"
      matTooltipPosition="above"
      class="ellipsis-text"
      (click)="$event.stopPropagation()">
      {{ displayText }}
    </span>
  `,
  styles: [
    `
      .ellipsis-text {
        cursor: default;
      }
    `,
  ],
})
export class EllipsisTooltipComponent {
  @Input() content: string = ''
  @Input() maxLength: number = 50

  get isTruncated(): boolean {
    return this.content.length > this.maxLength
  }

  get displayText(): string {
    if (this.content.length > this.maxLength) {
      return this.content.substring(0, this.maxLength) + '...'
    }
    return this.content
  }

  @HostListener('copy', ['$event'])
  onCopy(event: ClipboardEvent) {
    // Prevent the default copy behavior
    event.preventDefault()

    // Copy the full content instead
    if (event.clipboardData) {
      event.clipboardData.setData('text/plain', this.content)
    }
  }
}
